import filesize from 'filesize';
import { File } from '@app/core/models';
import {
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faFileCsv,
  faFile,
  IconDefinition,
} from '@fortawesome/pro-light-svg-icons';

export const VALID_EXTENSIONS: readonly string[] = [
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'csv',
  'txt',
];

export const isValidExtension = (ext: string): boolean =>
  VALID_EXTENSIONS.includes(ext);

const isFileType = (extensions: string[]) => (ext: string) =>
  extensions.includes(ext);

export const isPDFDocument = isFileType(['pdf']);
export const isWordDocument = isFileType(['doc', 'docx']);
export const isExcelDocument = isFileType(['xls', 'xlsx']);
export const isPowerpointDocument = isFileType(['ppt', 'pptx']);
export const isCSVDocument = isFileType(['csv']);
export const isTextFile = isFileType(['txt']);

export function getIcon(fileName: string): IconDefinition {
  const ext = getExtension(fileName);
  return isPDFDocument(ext)
    ? faFilePdf
    : isExcelDocument(ext)
    ? faFileExcel
    : isWordDocument(ext)
    ? faFileWord
    : isPowerpointDocument(ext)
    ? faFilePowerpoint
    : isCSVDocument(ext)
    ? faFileCsv
    : faFile;
}

export function getSize(bytes: number): string {
  return filesize(bytes, {
    round: 0,
  }).replace(' ', '');
}

export function getFileName(filePath: string): string {
  return filePath.split('/').pop()!;
}

export function getExtension(fileName: string): string {
  return fileName.split('.').pop()!;
}

export function getFilePathSegments(filePath: string): {
  directoryUrl: string;
  fileName: string;
} {
  const directoryUrl = filePath.split('/').slice(0, -1).join('/');
  const fileName = getFileName(filePath);
  return { directoryUrl, fileName };
}

export function isDocument(file: File.File): file is File.Document {
  return file.type === File.Type.DOCUMENT;
}

export function resolveIOSPath(uri: string): string {
  if (uri.startsWith('/private')) {
    return 'file://' + uri.slice(8);
  } else if (uri.startsWith('file')) {
    return uri;
  } else {
    throw Error('unknown ios file uri: ' + uri);
  }
}
